import { useGetProfileQuery } from "@/services/api/entities/profile";
import { handleFullName } from "@/shared/utils/handle-contacts-null";

export const useUserInfo = () => {
  const { data: profile } = useGetProfileQuery();

  const profileName = handleFullName(profile?.firstName, profile?.lastName);

  return { profileName };
};
